module.exports = __webpack_public_path__ + "static/img/Florence_Adhiambo_Anyango.77babd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Florence_Adhiambo_Anyango.png
// module id = vI3/
// module chunks = 1